import {
  fetchSearchedProducts,
  searchSelectors,
  setSearchedProducts,
} from "features/searchBar/searchSlice";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebounce } from "./useDebounce";

export const useSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const products = useSelector(searchSelectors.searchResult);
  const isSearching = useSelector(searchSelectors.selectSearching);
  const activeCategorySortingType = useSelector(
    searchSelectors.selectActiveSortingType
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const result = debouncedSearchTerm !== "" ? products : [];

  useEffect(() => {
    if (debouncedSearchTerm) {
      const filter = [{ name: "title", activeFilters: [debouncedSearchTerm] }];
      dispatch(
        fetchSearchedProducts(filter, 1, activeCategorySortingType, true)
      );
    } else {
      dispatch(setSearchedProducts([]));
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    dispatch(setSearchedProducts([]));
    setSearchTerm("");
  }, [location]);

  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setSearchTerm(event.target.value);
  };

  const viewAll = (event: any) => {
    navigate(`/search?page=1&title=${debouncedSearchTerm}`);
    event.preventDefault();
  };
  return { searchTerm, result, isSearching, viewAll, onSearch };
};
